@if(isVisible) {
    <div class="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center z-50">
        <div class="bg-white rounded-xl shadow-2xl p-8 w-full max-w-lg mx-4 animate-fade-in">
            <h2 class="text-2xl font-bold mb-4">{{ 'BETA_NOTICE.TITLE' | translate }}</h2>
            <p class="mb-6">{{ 'BETA_NOTICE.DESCRIPTION' | translate }}</p>

            <label class="flex items-center cursor-pointer mb-6">
                <input type="checkbox" [(ngModel)]="doNotShowAgain" class="form-checkbox h-5 w-5 text-primary-600 rounded mr-2" />
                <span class="text-sm">{{ 'BETA_NOTICE.DO_NOT_SHOW_AGAIN' | translate }}</span>
            </label>

            <div class="flex justify-end">
                <button (click)="dismissNotice()" class="px-5 py-2 bg-primary text-white rounded-lg hover:bg-primary-700 transition duration-200 ease-in-out" data-cy="dismiss-beta-notice">
                    {{ 'BETA_NOTICE.CONFIRM_BUTTON' | translate }}
                </button>
            </div>
        </div>
    </div>
}
